import { SectionContainerTypes } from '../../types';
import { SectionArticleHeader } from './../blog/article/header/ArticleHeaders';
import makeSectionContainer from './../hocs/makeSectionContainer';

export default makeSectionContainer({
  sectionType: SectionContainerTypes.PROJECT_MANAGEMENT,
  HeaderComponent: SectionArticleHeader,
  contentEditorProps: { hasEditableHeader: true },
});
